<h2 mat-dialog-title>Diente {{ fdi }} — {{ nombreFdi }}</h2>

<div mat-dialog-content [formGroup]="form" class="cara-popover">
  <section class="bloque-caras">
    <h3>Caras del diente</h3>
    <div class="caras-grid">
      <div *ngFor="let c of caras" class="cara-cell">
        <span class="cara-label">{{ c }}</span>
        <mat-form-field appearance="outline" class="cara-select">
          <mat-select
            [value]="(form.get('surfaces')?.value || {})[c] || null"
            (selectionChange)="setCara(c, $event.value)"
          >
            <mat-option [value]="null">— Sin hallazgo —</mat-option>
            <mat-option *ngFor="let cond of condicionesCara" [value]="cond.codigo">
              <span class="swatch" [style.background]="cond.color"></span> {{ cond.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </section>

  <section class="bloque-diente">
    <h3>Condición del diente completo</h3>
    <mat-form-field appearance="outline">
      <mat-select formControlName="tooth" (selectionChange)="onToothChange($event.value)">
        <mat-option [value]="null">— Ninguna —</mat-option>
        <mat-option *ngFor="let cond of condicionesDiente" [value]="cond.codigo">
          <span class="swatch" [style.background]="cond.color"></span> {{ cond.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </section>

  <section class="bloque-notas">
    <mat-form-field appearance="outline" class="notas-field">
      <mat-label>Notas del diente</mat-label>
      <textarea matInput formControlName="notas" rows="3" maxlength="500"></textarea>
    </mat-form-field>
  </section>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="limpiarDiente()">Limpiar diente</button>
  <button mat-button (click)="cancelar()">Cancelar</button>
  <button mat-flat-button class="btn-guardar-diente" (click)="guardar()">Guardar diente</button>
</div>
